import React, {useEffect, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import {toast, ToastContainer} from 'react-toastify';


//import service
import Spinner from "reactjs-simple-spinner";
import UserService from "../../../services/UserService";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import {MenuItem} from "@material-ui/core";
import PermissionsService from "../../../services/PermissionsService";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));

const ViewUser = () => {
    const [loading, setLoading] = useState(true);
    const [readUser, setReadUser] = useState({});
    const [role, setRole] = useState(null);
    const [permission, setPermission] = useState(null);
    const [roles, setRoles] = useState([])
    const [basicRoles, setBasicRoles] = useState([])
    const [data, setData] = useState([])
    const [permissions, setPermissions] = useState([])
    const [roleBasedPermissions, setRoleBasedPermissions] = useState([])
    const [open, setOpen] = useState(false);
    const [roleOpen, setRoleOpen] = useState(false);
    const [assignOpen, setAssignOpen] = useState(false);
    const [updateRoleLoading, setUpdateRoleLoading] = useState(false);
    const [updateUserLoading, setUpdateUserLoading] = useState(false);
    const [assignLoading, setAssignLoading] = useState(false);
    const classes = useStyles();

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };
    const handleRoleClose = () => {
        setRoleOpen(false);
    };

    const handleRoleOpen = () => {
        setRoleOpen(true);
    };



    const handleAssignClose = () => {
        setAssignOpen(false);
    };

    const handleAssignOpen = () => {
        setAssignOpen(true);
    };

    const stopLoading = () => {
        setLoading(false)
    }


    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        setAssignLoading(false);
        setUpdateUserLoading(false)
        setUpdateRoleLoading(false)

        handleClose()
        handleAssignClose()
        handleRoleClose()
        //    get user details
        let r = JSON.parse(localStorage.getItem('roles'));
        let u = JSON.parse(localStorage.getItem('viewUser'));
        console.log("user: ", u);
        UserService.getUser(u.id).then(res => {
            console.log("returned: ", res)
            setRoles(res.data.roles)
            setPermissions(res.data.permissions)
            setRoleBasedPermissions(res.data.role_based_permissions)
        }).catch(err => {
            console.log("error: ", err)
        })
        PermissionsService.getAll()
            .then(res => {
                console.log("res: ", res)
                if (res.status === 200) {
                    console.log(res.data);
                    setData(res.data.data);
                    UserService.getAllRoles()
                        .then(res => {
                            console.log(res.data);
                            let d = [];
                            res.data.data.map((roles, i) => {
                                if (roles[0].name !== 'sysadmin') {
                                    d.push(roles[0])
                                }
                            })
                            console.log("data: ", d)
                            setBasicRoles(d)
                            setLoading(false);
                        })
                        .catch(err => {
                            console.log(err);
                            setBasicRoles([])
                            setLoading(false);
                        });
                } else {
                    setData([]);
                    console.log("res: ", res.response.data.message)
                    setLoading(false);
                }

            })
            .catch(err => {
                console.log(err.response.data.message);
                setData([]);
                setLoading(false);
            });
        console.log("roles: ", r);

        setReadUser(u);

        setTimeout(stopLoading, 3000);


    }, []);

    const handleUpdateUser = () => {
        setUpdateUserLoading(true);
        console.log("user request: ", readUser)
        UserService.updateAccount(readUser)
            .then(res => {
                console.log("res: ", res)
                if (res.status == 200) {
                    setLoading(true);
                    handleClose()
                    setUpdateUserLoading(false)
                    console.log(res);
                    toast(' User Updated ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setReadUser(res.data.user)
                    setRoles(res.data.roles)
                    setPermissions(res.data.permissions)
                    setRoleBasedPermissions(res.data.role_based_permissions)
                    setLoading(false)
                } else {
                    console.log(res);
                    toast.error('Operation failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateUserLoading(false)
                }
            }).catch(err => {
            console.log("error: ", err)
            toast.error('Operation failed: ' + err.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setUpdateUserLoading(false)
        })

    }

    const handleUpdateRole = () => {
        setUpdateRoleLoading(true)
        console.log("role request: ", role)
        let data = {
            'id': readUser.id,
            'role_id': role.role
        }
        UserService.changeRole(data).then(res => {
            console.log("res: ", res)
            if (res.status == 200) {
                setLoading(true);
                handleRoleClose()
                setUpdateRoleLoading(false)
                console.log(res);
                toast(' User Updated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setReadUser(res.data.user)
                setRoles(res.data.roles)
                setPermissions(res.data.permissions)
                setRoleBasedPermissions(res.data.role_based_permissions)
                setLoading(false)
            } else {
                console.log(res);
                toast.error('Operation failed: ' + res.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateRoleLoading(false)
            }
        }).catch(err => {
            console.log("error: ", err)
            toast.error('Operation failed: ' + err.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setUpdateRoleLoading(false)
        })
    }

    const handleAssignPermission = () => {
        setAssignLoading(true)
        console.log("permission request: ", permission)
        let data = {
            'id': readUser.id,
            'permission': permission.name
        }

        UserService.assignDirectPermission(data).then(res => {
            console.log("res: ", res)
            if (res.status == 200) {
                setLoading(true);
                handleAssignClose()
                setAssignLoading(false)
                console.log(res);
                toast(' User permission assigned ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setReadUser(res.data.user)
                setRoles(res.data.roles)
                setPermissions(res.data.permissions)
                setRoleBasedPermissions(res.data.role_based_permissions)
                setLoading(false)
            } else {
                console.log(res);
                toast.error('Operation failed: ' + res.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setAssignLoading(false)
            }
        }).catch(err => {
            console.log("error: ", err)
            toast.error('Operation failed: ' + err.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setAssignLoading(false)
        })
    }

    const handleUnAssignPermission = (permission) => {
        setLoading(true)
        console.log("permission request: ", permission)
        let data = {
            'id': readUser.id,
            'permission': permission
        }

        UserService.unAssignDirectPermission(data).then(res => {
            console.log("res: ", res)
            if (res.status == 200) {
                console.log(res);
                toast(' User permission revoked ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setReadUser(res.data.user)
                setRoles(res.data.roles)
                setPermissions(res.data.permissions)
                setRoleBasedPermissions(res.data.role_based_permissions)
                setLoading(false)
            } else {
                console.log(res);
                toast.error('Operation failed: ' + res.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLoading(false)
            }
        }).catch(err => {
            console.log("error: ", err)
            toast.error('Operation failed: ' + err.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false)
        })
    }

    const handleRoleChange = name => ({target: {value}}) => {
        setRole({...role, [name]: value})
    }

    const handleUserChange = name => ({target: {value}}) => {
        setReadUser({...readUser, [name]: value})
    }

    const handlePermissionChange = name => ({target: { value }}) => {
        setPermission({...permission, [name]: value})
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* Same as */}
            <ToastContainer/>


            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content"
                className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                {/*
                    Modals
                */}

                {/*update user*/}
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <div>
                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="form-dialog-title"
                                >
                                    <DialogTitle id="form-dialog-title">Update User Details</DialogTitle>
                                    {updateUserLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Updating user details,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!updateUserLoading && (
                                        <>
                                            <DialogContent>
                                                <DialogContentText></DialogContentText>
                                                <TextField
                                                    margin="dense"
                                                    label="Email"
                                                    type="text"
                                                    value={readUser.email}
                                                    fullWidth
                                                    onChange={handleUserChange('email')}
                                                />
                                                <TextField
                                                    margin="dense"
                                                    label="FirstName"
                                                    type="text"
                                                    value={readUser.firstName}
                                                    fullWidth
                                                    onChange={handleUserChange('firstName')}
                                                />
                                                <TextField
                                                    margin="dense"
                                                    label="LastName"
                                                    type="text"
                                                    value={readUser.lastName}
                                                    fullWidth
                                                    onChange={handleUserChange('lastName')}
                                                />

                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleClose} color="primary">
                                                    Cancel
                                                </Button>
                                                <Button onClick={handleUpdateUser}
                                                        className="btn btn-round btn-sm btn-primary">
                                                    Update User
                                                </Button>
                                            </DialogActions>
                                        </>
                                    )}

                                </Dialog>
                            </div>
                        </div>
                    </Fade>
                </Modal>

                {/*update role*/}
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={roleOpen}
                    onClose={handleRoleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={roleOpen}>
                        <div className={classes.paper}>
                            <div className="p-5">
                                <Dialog
                                    open={roleOpen}
                                    onClose={handleRoleClose}
                                    aria-labelledby="form-dialog-title"
                                >
                                    <DialogTitle id="form-dialog-title">Update User Role</DialogTitle>
                                    {updateRoleLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Updating role,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!updateRoleLoading && (
                                        <>
                                            <DialogContent>
                                                <DialogContentText></DialogContentText>
                                                <TextField
                                                    name="role"
                                                    required
                                                    select
                                                    fullWidth
                                                    onChange={handleRoleChange('role')}
                                                >
                                                    <MenuItem disabled={true} value>Select Role</MenuItem>
                                                    {basicRoles.map((a, i) => {
                                                        if (a.name !== 'sysadmin') {
                                                            return (
                                                                <MenuItem value={a.id}>{a.name}</MenuItem>
                                                            )
                                                        }

                                                    })}

                                                </TextField>

                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleRoleClose} color="primary">
                                                    Cancel
                                                </Button>
                                                <Button onClick={handleUpdateRole}
                                                        className="btn btn-round btn-sm btn-primary">
                                                    Update Role
                                                </Button>
                                            </DialogActions>
                                        </>
                                    )}

                                </Dialog>
                            </div>
                        </div>
                    </Fade>
                </Modal>

                {/*assign permission*/}
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={assignOpen}
                    onClose={handleAssignClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={assignOpen}>
                        <div className={classes.paper}>
                            <div>
                                <Dialog
                                    open={assignOpen}
                                    onClose={handleAssignClose}
                                    aria-labelledby="form-dialog-title"
                                >
                                    <DialogTitle id="form-dialog-title">Assign Direct Permission To User</DialogTitle>
                                    {assignLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Assigning permission,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!assignLoading && (
                                        <>
                                            <DialogContent>
                                                <DialogContentText></DialogContentText>
                                                <TextField
                                                    name="Permission"
                                                    required
                                                    select
                                                    fullWidth
                                                    onChange={handlePermissionChange('name')}
                                                >
                                                    <MenuItem disabled={true} value>Select Permission</MenuItem>
                                                    {data.map((a, i) => (
                                                        <MenuItem value={a.name}>{a.name}</MenuItem>
                                                    )
                                                    )}
                                                </TextField>


                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleAssignClose} color="primary">
                                                    Cancel
                                                </Button>
                                                <Button onClick={handleAssignPermission}
                                                        className="btn btn-round btn-sm btn-primary">
                                                    Assign Permission
                                                </Button>
                                            </DialogActions>
                                        </>
                                    )}

                                </Dialog>
                            </div>
                        </div>
                    </Fade>
                </Modal>

                {/*
                    End Modals
                */}
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/users"><a href><i className="fa fa-backward"></i>&nbsp;Users</a> /</Link>
                            &nbsp;
                            <span className="upper-class">{readUser.firstName}&nbsp;{readUser.lastName}</span>
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Getting User Data,Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        )}
                        {!loading && (
                            <div className="row mt">
                                <div className="card col-lg-12">
                                    <div className="content-panel bg-white p-2">

                                        <h3 className="title h3">User Details</h3>

                                        <hr/>
                                        <div className="row mb-3">
                                            <div className="col-md-3">
                                                <h4>Email: {readUser.email}</h4>
                                            </div>
                                            <div className="col-md-3">
                                                <h4>Status:&nbsp;
                                                {readUser.status == "1" ? (
                                                    <button
                                                        className="btn btn-round btn-sm btn-success">Active</button>
                                                ) : (
                                                    <button
                                                        className="btn btn-round btn-sm btn-danger">Disabled</button>
                                                )}
                                                </h4>
                                            </div>
                                            <div className="col-md-3">
                                                <h4>FirstName: {readUser.firstName}</h4>
                                            </div>
                                            <div className="col-md-3">
                                                <h4>LastName: {readUser.lastName}</h4>
                                            </div>
                                        </div>
                                        <div className="row ml-auto">
                                            <button onClick={handleOpen} className="btn btn-sm btn-primary">Update User
                                                Details
                                            </button>
                                        </div>
                                        <hr/>
                                        <h3 className="title h4 font-weight-bold text-center ">Manage User Roles &
                                            Permissions</h3>
                                        <hr/>
                                        <div className="row">
                                            <div className="col-md-6 container">
                                                <table className="table table-responsive table-striped" id="table">
                                                    <thead>
                                                    <th><h4 className=""><b>Role</b></h4></th>
                                                    <th></th>
                                                    <th>Action</th>

                                                    </thead>
                                                    <tbody>
                                                    {/*iterate roles*/}
                                                    {roles.map((role, i) => {
                                                        return (
                                                            <>

                                                                <tr key={i}>
                                                                    <td>
                                                                        <h5 className=""><b><span
                                                                            className="text-uppercase">{role}</span></b>
                                                                        </h5>
                                                                    </td>
                                                                    <th></th>
                                                                    <th>
                                                                        <button onClick={handleRoleOpen}
                                                                                className="btn btn-sm btn-primary">Update
                                                                            User Role
                                                                        </button>
                                                                    </th>

                                                                </tr>

                                                            </>
                                                        )

                                                    })}
                                                    <tr className="bg-white">
                                                        <th><h4 className=""><b>Role Based Permissions</b>
                                                        </h4>
                                                        </th>
                                                        <th>
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                    <tr className="bg-white">
                                                        <th>id
                                                        </th>
                                                        <th>
                                                        </th>
                                                        <th>Authority</th>
                                                    </tr>
                                                    {roleBasedPermissions.map((permission, p) => {
                                                        return (
                                                            <tr key={p}>
                                                                <td>
                                                                    {permission.id}
                                                                </td>
                                                                <td></td>
                                                                <td>
                                                                    {permission.name}
                                                                </td>

                                                            </tr>
                                                        )
                                                    })}
                                                    <tr className="bg-white">
                                                        <th><h4 className=""><b>Direct Permissions</b>
                                                        </h4>
                                                        </th>
                                                        <th></th>
                                                        <th>
                                                            <button onClick={handleAssignOpen}
                                                                    className="btn btn-sm btn-primary">Assign Direct
                                                                Permission
                                                            </button>
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <th>id</th>
                                                        <th>authority</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {permissions.map((permission, p) => {
                                                        return (
                                                            <tr key={p}>
                                                                <td>
                                                                    {permission.id}
                                                                </td>
                                                                <td>
                                                                    {permission.name}
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        onClick={() => handleUnAssignPermission(permission.name)}
                                                                        className="btn btn-sm btn-danger">
                                                                        unAssign Direct Permission&nbsp;<i
                                                                        className="fa fa-remove"/>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    )

}

export default ViewUser;
